import { render, staticRenderFns } from "./InventoryItem.component.vue?vue&type=template&id=a7a8e8f4&scoped=true&"
import script from "./InventoryItem.component.vue?vue&type=script&lang=js&"
export * from "./InventoryItem.component.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItem.component.vue?vue&type=style&index=0&id=a7a8e8f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a8e8f4",
  null
  
)

export default component.exports